import React, { useEffect, useState } from "react";
import { storedProcedure } from "../../utils/storedProceduresConfig";
import HTTPRequest from "../shared-components/HTTPRequest";
import DetailsSummary from "./confirmation-components/DetailsSummary";
import OrderMessage from "./confirmation-components/OrderMessage";
import OrderSummary from "./confirmation-components/OrderSummary";
import MissingOrder from "../shared-components/error-messages/MissingOrder";
import { useSearchParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Confimation = (props) => {
	let [searchParams, setSearchParams] = useSearchParams();
	const [paperPackage, setPaperPackage] = useState(false);
	const getOrder = () => {
		// this is a call to the stored proceedure wrapped in a promise
		const hash = getUrlHash(searchParams.toString());
		return storedProcedure.getCompletedOrder.requestObject(hash);
	};

	const getUrlHash = (location) => {
		const url = location;
		const hashParamIdentifier = "s=";
		// find the start of the hash param and start after the '=' sign
		const startOfHash = url.indexOf(hashParamIdentifier) + hashParamIdentifier.length;
		const urlMD5Hash = url.slice(startOfHash, url.length);
		return urlMD5Hash;
	};

	const getOrderBasket = (order, packageCatalog) => {
		// packageArray and additionalUserArray are returned as comma seporated values but
		// they need to be converted into an array
		const { ArrayProducts = "", quantArray = "", packageQuantityArray = "" } = order;
		const additionalUserArray = quantArray.split(",");

		/*
		 * NB: for older orders where packageQuantityArray will be null,
		 * use the length of the ArrayProducts and return 1 for each time there is a
		 * packacge item.
		 */
		let packageQuantityArrayValues;
		if (packageQuantityArray === null) {
			const emptyArray = new Array(quantArray.length);
			packageQuantityArrayValues = emptyArray.map(() => 1);
		} else {
			packageQuantityArrayValues = packageQuantityArray.split(",");
		}

		// convert the productID string ie("PK_TB_153") to a productID ie(153)
		const convertProductIDToPackageID = (productIDs) => {
			if (productIDs.length > 0) {
				return productIDs.map((packageItem) => {
					if (typeof packageItem === "string") {
						const startOfPackageID = packageItem.lastIndexOf("_") + 1;
						const packageID = packageItem.substring(startOfPackageID);
						return Number(packageID);
					} else {
						return packageItem;
					}
				});
			} else {
				return productIDs;
			}
		};

		const purchasedPackagesArray = convertProductIDToPackageID(ArrayProducts.split(","));
		// first map over the packages the user has purchaed to put them into the getOrderBasket
		// then map over the list of packages DS sells to fill in the missing DetailsSummary
		// return the populated basket

		const formattedPackages = purchasedPackagesArray.map((item, index) => {
			return {
				packageID: item,
				additionalUsers: additionalUserArray[index],
				packageQuantity: packageQuantityArrayValues[index],
			};
		});

		const basket = formattedPackages.map((item) => {
			const result = packageCatalog.find((product) => {
				if (product.packageID === item.packageID) {
					product.additionalUsers = Number(item.additionalUsers);
					product.packageQuantity = Number(item.packageQuantity);
					return product;
				}
				return null;
			});
			return result;
		});

		return basket;
	};

	const DiscountCodeMessage = ({ code }) => (
		<p>
			Discount code: <b>{code}</b>
		</p>
	);
	return (
		<HTTPRequest
			url={storedProcedure.getCompletedOrder.url}
			requestObject={getOrder()}
			loadingComponent={() => (
				<Col xs={12} style={{ textAlign: "center" }}>
					<br />
					<div />
					<h1>Just getting your order...</h1>
				</Col>
			)}
			customErrorCondition={(data) => data.length === 0}
			errorComponent={() => <MissingOrder brandName={props.brand.name} />}
			setPackages={props.setPackages}
		>
			{(result) => {
				const { recnum, financeemail, org: centreName, promo_code: discountCode } = result[0];
				const basketItems = getOrderBasket(result[0], props.packages);
				const basketZero = basketItems.map((basket, index) =>
					basket.price === ".0000" ? 0 : parseInt(basket.price, 10)
				);
				const basketSubTotal = basketZero.reduce((a, b) => a + b, 0);
				const findFamilyID = (basketItems, id) => {
					return basketItems.some((item) => item.familyID === id);
				};
				const familyIDToFind = 15;
				const exists = findFamilyID(basketItems, familyIDToFind);
				setPaperPackage(exists);
				const basketSubTotalToNumber = parseInt(basketSubTotal) || 0;
				return result.length === 0 ? (
					<div> ah no results</div>
				) : (
					<Container fluid style={{ padding: 30 }}>
						<Row>
							<Col xs={12} sm={6}>
								<h1 style={{ marginTop: "0px" }}>Thank you {centreName}!</h1>

								<DetailsSummary schoolDetails={result[0]} basket={basketItems} />
								<br />
								{basketItems.length ? (
									basketSubTotalToNumber > 0 ? (
										<DiscountCodeMessage className="promo-code__message" code={discountCode} />
									) : (
										""
									)
								) : (
									""
								)}
							</Col>
							<Col xs={12} sm={6}>
								<OrderMessage recnum={recnum} financeemail={financeemail} />
								<div className="fixed-summary">
									<OrderSummary basket={basketItems} paperPackage={paperPackage} />
									<Row style={{ marginTop: 24 }} className="order-drawer__addusers-msg">
										{paperPackage ? (
											<p style={{ margin: 0 }}>
												<strong>
													**Please note: a Complete Primary Package subscription is required to
													order printed tests.
												</strong>
												<br />
												Please ensure you have renewed your current subscription before purchase.
											</p>
										) : (
											""
										)}
									</Row>
								</div>
							</Col>
						</Row>
					</Container>
				);
			}}
		</HTTPRequest>
	);
};

export default Confimation;
